import { useState } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

export default function MeatMechanicPage() {
  const [activeCategory, setActiveCategory] = useState('All');
  const [showSubscribeModal, setShowSubscribeModal] = useState(false);

  const recipes = [
    {
      id: 1,
      title: 'Smoked Brisket Perfection',
      category: 'Dinner',
      image: 'https://public.readdy.ai/ai/img_res/2a5bf88cea3f99e729857c505909c2c6.jpg',
      date: 'Jan 15, 2025',
      readTime: '8 min',
      excerpt: 'Master the art of smoking brisket with this comprehensive guide to achieving tender, flavorful results every time.',
    },
    {
      id: 2,
      title: 'Herb-Crusted Lamb Chops',
      category: 'Dinner',
      image: 'https://readdy.ai/api/search-image?query=herb%20crusted%20lamb%20chops%20on%20white%20plate%20with%20fresh%20herbs%20rustic%20elegant%20presentation%20warm%20lighting%20simple%20seafoam%20green%20background%20gourmet%20meat%20dish%20oceanic%20tones&width=600&height=400&seq=recipe002b&orientation=landscape',
      date: 'Jan 12, 2025',
      readTime: '6 min',
      excerpt: 'Elevate your dinner with these succulent lamb chops featuring a fragrant herb crust and perfect sear.',
    },
    {
      id: 3,
      title: 'Breakfast Sausage Patties',
      category: 'Breakfast',
      image: 'https://readdy.ai/api/search-image?query=homemade%20breakfast%20sausage%20patties%20on%20rustic%20wooden%20board%20morning%20light%20simple%20seafoam%20green%20background%20artisan%20meat%20preparation%20fresh%20herbs%20oceanic%20tones&width=600&height=400&seq=recipe003b&orientation=landscape',
      date: 'Jan 10, 2025',
      readTime: '5 min',
      excerpt: 'Start your day right with homemade breakfast sausage patties seasoned to perfection with aromatic spices.',
    },
    {
      id: 4,
      title: 'Grilled Ribeye Steak',
      category: 'Dinner',
      image: 'https://readdy.ai/api/search-image?query=perfectly%20grilled%20ribeye%20steak%20with%20grill%20marks%20on%20wooden%20cutting%20board%20rustic%20presentation%20warm%20lighting%20simple%20seafoam%20green%20background%20premium%20beef%20oceanic%20tones&width=600&height=400&seq=recipe004b&orientation=landscape',
      date: 'Jan 8, 2025',
      readTime: '7 min',
      excerpt: 'Learn the secrets to grilling the perfect ribeye steak with a beautiful crust and juicy interior.',
    },
    {
      id: 5,
      title: 'Pulled Pork Sandwiches',
      category: 'Lunch',
      image: 'https://readdy.ai/api/search-image?query=pulled%20pork%20sandwich%20on%20brioche%20bun%20rustic%20presentation%20warm%20natural%20lighting%20simple%20seafoam%20green%20background%20artisan%20barbecue%20food%20styling%20oceanic%20tones&width=600&height=400&seq=recipe005b&orientation=landscape',
      date: 'Jan 5, 2025',
      readTime: '10 min',
      excerpt: 'Slow-cooked pulled pork that falls apart at the touch, perfect for sandwiches and gatherings.',
    },
    {
      id: 6,
      title: 'Bacon-Wrapped Dates',
      category: 'Snacks',
      image: 'https://readdy.ai/api/search-image?query=bacon%20wrapped%20dates%20appetizer%20on%20white%20plate%20elegant%20presentation%20warm%20lighting%20simple%20seafoam%20green%20background%20gourmet%20snack%20food%20styling%20oceanic%20tones&width=600&height=400&seq=recipe006b&orientation=landscape',
      date: 'Jan 3, 2025',
      readTime: '4 min',
      excerpt: 'The perfect appetizer combining sweet dates with savory bacon for an irresistible flavor combination.',
    },
  ];

  const galleryItems = [
    {
      id: 1,
      name: 'Smoked Ribs',
      category: 'Dinner',
      difficulty: 'Medium',
      time: '4 hours',
      image: 'https://readdy.ai/api/search-image?query=smoked%20pork%20ribs%20with%20barbecue%20glaze%20on%20wooden%20board%20rustic%20presentation%20warm%20lighting%20simple%20seafoam%20green%20background%20artisan%20meat%20preparation%20oceanic%20tones&width=500&height=500&seq=gallery001b&orientation=squarish',
    },
    {
      id: 2,
      name: 'Beef Wellington',
      category: 'Dinner',
      difficulty: 'Hard',
      time: '2 hours',
      image: 'https://readdy.ai/api/search-image?query=beef%20wellington%20sliced%20showing%20pink%20center%20on%20white%20plate%20elegant%20presentation%20warm%20lighting%20simple%20seafoam%20green%20background%20gourmet%20dish%20oceanic%20tones&width=500&height=500&seq=gallery002b&orientation=squarish',
    },
    {
      id: 3,
      name: 'Chicken Teriyaki',
      category: 'Lunch',
      difficulty: 'Easy',
      time: '30 min',
      image: 'https://readdy.ai/api/search-image?query=chicken%20teriyaki%20with%20vegetables%20on%20white%20plate%20asian%20inspired%20presentation%20warm%20lighting%20simple%20seafoam%20green%20background%20healthy%20meal%20oceanic%20tones&width=500&height=500&seq=gallery003b&orientation=squarish',
    },
    {
      id: 4,
      name: 'Pork Tenderloin',
      category: 'Dinner',
      difficulty: 'Medium',
      time: '45 min',
      image: 'https://readdy.ai/api/search-image?query=sliced%20pork%20tenderloin%20with%20herbs%20on%20wooden%20board%20rustic%20presentation%20warm%20lighting%20simple%20seafoam%20green%20background%20artisan%20meat%20dish%20oceanic%20tones&width=500&height=500&seq=gallery004b&orientation=squarish',
    },
    {
      id: 5,
      name: 'Breakfast Burrito',
      category: 'Breakfast',
      difficulty: 'Easy',
      time: '20 min',
      image: 'https://readdy.ai/api/search-image?query=breakfast%20burrito%20cut%20in%20half%20showing%20filling%20on%20white%20plate%20morning%20light%20simple%20seafoam%20green%20background%20hearty%20breakfast%20oceanic%20tones&width=500&height=500&seq=gallery005b&orientation=squarish',
    },
    {
      id: 6,
      name: 'Meatball Sub',
      category: 'Lunch',
      difficulty: 'Easy',
      time: '35 min',
      image: 'https://readdy.ai/api/search-image?query=meatball%20sub%20sandwich%20with%20melted%20cheese%20on%20rustic%20board%20warm%20lighting%20simple%20seafoam%20green%20background%20comfort%20food%20styling%20oceanic%20tones&width=500&height=500&seq=gallery006b&orientation=squarish',
    },
    {
      id: 7,
      name: 'Steak Tacos',
      category: 'Dinner',
      difficulty: 'Easy',
      time: '25 min',
      image: 'https://readdy.ai/api/search-image?query=steak%20tacos%20with%20fresh%20toppings%20on%20wooden%20board%20rustic%20presentation%20warm%20lighting%20simple%20seafoam%20green%20background%20mexican%20inspired%20oceanic%20tones&width=500&height=500&seq=gallery007b&orientation=squarish',
    },
    {
      id: 8,
      name: 'BBQ Chicken Wings',
      category: 'Snacks',
      difficulty: 'Easy',
      time: '40 min',
      image: 'https://readdy.ai/api/search-image?query=barbecue%20chicken%20wings%20with%20sauce%20on%20white%20plate%20appetizer%20presentation%20warm%20lighting%20simple%20seafoam%20green%20background%20party%20food%20oceanic%20tones&width=500&height=500&seq=gallery008b&orientation=squarish',
    },
  ];

  const filteredRecipes =
    activeCategory === 'All'
      ? recipes
      : recipes.filter((r) => r.category === activeCategory);

  const handleSubscribeSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d5i17drgekujqjrtsrug', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        alert('Welcome to Meat Mechanic! Check your email for exclusive recipes.');
        setShowSubscribeModal(false);
        form.reset();
      } else {
        alert('Something went wrong. Please try again.');
      }
    } catch (error) {
      alert('Error submitting form. Please try again.');
    }
  };

  return (
    <div className="min-h-screen bg-[#F0F9F7]">
      <Navigation />

      {/* Hero Section */}
      <section className="relative h-[65vh] flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#E8F5F1] via-[#E0F0EB] to-[#D8EBE5]">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-20"
          style={{
            backgroundImage:
              'url(https://readdy.ai/api/search-image?query=rustic%20culinary%20background%20with%20fresh%20ingredients%20wooden%20cutting%20board%20herbs%20spices%20premium%20meat%20cuts%20warm%20natural%20lighting%20seafoam%20green%20and%20aqua%20tones%20artisan%20cooking%20scene%20oceanic%20colors&width=1920&height=1080&seq=mmhero001b&orientation=landscape)',
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#E8F5F1]/60 via-[#E8F5F1]/40 to-[#E8F5F1]/70"></div>

        <div className="relative z-10 text-center px-8 max-w-4xl">
          <div className="inline-block mb-6">
            <span className="px-6 py-2 border-2 border-[#2C7A7B] text-[#2C7A7B] text-xs uppercase tracking-[0.3em] font-light rounded-full bg-white/50">
              Culinary Excellence
            </span>
          </div>
          <h1 className="text-7xl lg:text-8xl font-black text-[#1A4D4D] mb-4 leading-none font-serif">
            MEAT MECHANIC
          </h1>
          <p className="text-2xl text-[#2C7A7B] mb-12 font-light">
            Artisan recipes &amp; meal prep mastery
          </p>

          <button
            onClick={() => setShowSubscribeModal(true)}
            className="bg-[#06B6D4] hover:bg-[#0891b2] text-white px-12 py-5 rounded-full text-sm uppercase tracking-widest font-medium transition-all duration-300 inline-flex items-center space-x-3 whitespace-nowrap"
          >
            <i className="ri-restaurant-line text-xl"></i>
            <span>Explore Recipes</span>
          </button>
        </div>

        {/* Decorative Food Image */}
        <div className="absolute bottom-0 right-0 w-96 h-96 hidden lg:block">
          <div className="relative w-full h-full">
            <div className="absolute inset-0 border-8 border-[#2C7A7B] rounded-full overflow-hidden transform translate-x-1/4 translate-y-1/4">
              <img
                src="https://readdy.ai/api/search-image?query=premium%20meat%20cut%20with%20fresh%20herbs%20on%20wooden%20board%20top%20view%20rustic%20food%20photography%20warm%20natural%20lighting%20simple%20seafoam%20green%20background%20artisan%20culinary%20styling%20oceanic%20tones&width=600&height=600&seq=deco001b&orientation=squarish"
                alt="Culinary"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Featured Recipe Spotlight */}
      <section className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-8 lg:px-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=featured%20gourmet%20meat%20dish%20beautifully%20plated%20with%20garnish%20professional%20food%20photography%20warm%20lighting%20simple%20seafoam%20green%20background%20artisan%20culinary%20presentation%20oceanic%20tones&width=800&height=600&seq=featured001b&orientation=landscape"
                alt="Featured Recipe"
                className="w-full h-96 object-cover rounded-2xl shadow-xl"
              />
            </div>

            <div className="space-y-6">
              <span className="text-[#06B6D4] text-xs uppercase tracking-[0.3em] font-light">
                Featured Recipe
              </span>
              <h2 className="text-5xl font-bold text-[#1A4D4D] font-serif leading-tight">
                Slow-Roasted Prime Rib
              </h2>

              <div className="flex items-center space-x-4">
                <span className="px-4 py-2 bg-[#E8F5F1] text-[#2C7A7B] text-sm rounded-full">
                  Prep: 20 min
                </span>
                <span className="px-4 py-2 bg-[#E8F5F1] text-[#2C7A7B] text-sm rounded-full">
                  Cook: 3 hours
                </span>
                <span className="px-4 py-2 bg-[#E8F5F1] text-[#2C7A7B] text-sm rounded-full">
                  Serves: 8
                </span>
              </div>

              <p className="text-lg text-[#2C7A7B] leading-relaxed">
                A show-stopping centerpiece for any special occasion. This prime rib recipe delivers a perfectly seasoned crust with a tender, juicy interior that will impress your guests.
              </p>

              <button className="border-2 border-[#2C7A7B] hover:bg-[#2C7A7B] hover:text-white text-[#2C7A7B] px-10 py-4 rounded-lg text-sm uppercase tracking-widest font-medium transition-all duration-300 inline-flex items-center space-x-3 whitespace-nowrap">
                <span>View Full Recipe</span>
                <i className="ri-arrow-right-line text-lg"></i>
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Blog Layout Grid */}
      <section className="bg-[#F0F9F7] py-24">
        <div className="max-w-7xl mx-auto px-8 lg:px-16">
          <div className="mb-16">
            <span className="text-[#2C7A7B] text-sm font-light mb-4 block">
              /LATEST RECIPES
            </span>
            <h2 className="text-6xl lg:text-7xl font-light text-[#1A4D4D] font-serif mb-8">
              FROM THE KITCHEN
            </h2>

            <div className="flex flex-wrap gap-4 mt-8">
              {['All', 'Breakfast', 'Lunch', 'Dinner', 'Snacks'].map((category) => (
                <button
                  key={category}
                  onClick={() => setActiveCategory(category)}
                  className={`px-6 py-2 rounded-full text-sm uppercase tracking-wider font-medium transition-all duration-300 whitespace-nowrap ${
                    activeCategory === category
                      ? 'bg-[#06B6D4] text-white'
                      : 'border-2 border-[#2C7A7B] text-[#2C7A7B] hover:border-[#06B6D4] hover:text-[#06B6D4]'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredRecipes.map((recipe) => (
              <article
                key={recipe.id}
                className="bg-white rounded-lg overflow-hidden hover:transform hover:-translate-y-1 transition-all duration-300 shadow-md hover:shadow-xl group"
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={recipe.image}
                    alt={recipe.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>

                <div className="p-6">
                  <span className="inline-block px-3 py-1 bg-[#06B6D4] text-white text-xs rounded-full uppercase tracking-wide mb-3">
                    {recipe.category}
                  </span>

                  <h3 className="text-2xl font-medium text-[#1A4D4D] font-serif mb-3 line-clamp-2">
                    {recipe.title}
                  </h3>

                  <div className="flex items-center space-x-3 text-sm text-[#2C7A7B] mb-4">
                    <span>{recipe.date}</span>
                    <span>•</span>
                    <span>{recipe.readTime} read</span>
                  </div>

                  <p className="text-gray-600 text-sm leading-relaxed mb-4 line-clamp-3">
                    {recipe.excerpt}
                  </p>

                  <a
                    href="#"
                    className="inline-flex items-center space-x-2 text-[#06B6D4] hover:text-[#0891b2] text-sm font-medium transition-colors group/link"
                  >
                    <span>Read More</span>
                    <i className="ri-arrow-right-line group-hover/link:translate-x-1 transition-transform"></i>
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Subscription Gateway Section */}
      <section className="relative bg-gradient-to-br from-[#1A4D4D] to-[#2C7A7B] py-24 overflow-hidden">
        <div className="absolute inset-0 bg-[#06B6D4] opacity-10"></div>
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#06B6D4] opacity-5 blur-3xl rounded-full"></div>

        <div className="relative max-w-4xl mx-auto px-8 text-center">
          <div className="flex justify-center mb-8">
            <div className="w-20 h-20 border-4 border-[#06B6D4] rounded-full flex items-center justify-center">
              <i className="ri-mail-line text-[#06B6D4] text-4xl"></i>
            </div>
          </div>

          <h2 className="text-5xl lg:text-6xl font-bold text-white font-serif mb-6 leading-tight">
            UNLOCK PREMIUM RECIPES
          </h2>
          <p className="text-xl text-[#E8F5F1] mb-12 font-light">
            Join our community for exclusive meal prep guides and in-depth recipes
          </p>

          <form
            id="newsletter-form"
            data-readdy-form
            onSubmit={handleSubscribeSubmit}
            className="max-w-2xl mx-auto"
          >
            <div className="relative flex items-center">
              <input
                type="email"
                name="email"
                placeholder="Enter your email address"
                required
                className="w-full h-16 bg-white rounded-l-full px-8 text-[#1A4D4D] text-lg focus:outline-none"
              />
              <button
                type="submit"
                className="h-16 w-16 bg-[#06B6D4] hover:bg-[#0891b2] rounded-full flex items-center justify-center transition-colors flex-shrink-0"
                aria-label="Subscribe"
              >
                <i className="ri-arrow-right-line text-white text-2xl"></i>
              </button>
            </div>
          </form>

          <div className="flex items-center justify-center space-x-2 mt-6">
            <i className="ri-check-line text-[#06B6D4] text-xl"></i>
            <p className="text-sm text-[#E8F5F1]">
              Access 200+ in-depth recipes instantly
            </p>
          </div>

          <p className="text-xs text-gray-400 mt-4">
            We respect your privacy. Unsubscribe at any time.
          </p>
        </div>
      </section>

      {/* Recipe Gallery */}
      <section className="bg-white py-24">
        <div className="max-w-7xl mx-auto px-8 lg:px-16">
          <h2 className="text-6xl lg:text-7xl font-light text-[#1A4D4D] font-serif text-center mb-16">
            RECIPE COLLECTION
          </h2>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {galleryItems.map((item) => (
              <div
                key={item.id}
                className="relative aspect-square rounded-xl overflow-hidden group cursor-pointer"
              >
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />

                <div className="absolute inset-0 bg-gradient-to-t from-[#1A4D4D] via-[#1A4D4D]/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h3 className="text-xl font-bold text-white mb-3">{item.name}</h3>
                    <div className="flex items-center space-x-2">
                      <span className="px-3 py-1 bg-white/20 backdrop-blur-sm text-white text-xs rounded-full">
                        {item.difficulty}
                      </span>
                      <span className="px-3 py-1 bg-white/20 backdrop-blur-sm text-white text-xs rounded-full">
                        {item.time}
                      </span>
                    </div>
                  </div>

                  <button
                    className="absolute top-4 right-4 w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-[#06B6D4] transition-colors"
                    aria-label="Favorite"
                  >
                    <i className="ri-heart-line text-white text-lg"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Subscribe Modal */}
      {showSubscribeModal && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl max-w-md w-full p-8 relative">
            <button
              onClick={() => setShowSubscribeModal(false)}
              className="absolute top-6 right-6 text-gray-400 hover:text-[#1A4D4D] transition-colors w-10 h-10 flex items-center justify-center"
              aria-label="Close"
            >
              <i className="ri-close-line text-3xl"></i>
            </button>

            <div className="text-center mb-8">
              <div className="w-16 h-16 bg-[#06B6D4] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-restaurant-line text-white text-3xl"></i>
              </div>
              <h3 className="text-3xl font-bold text-[#1A4D4D] font-serif mb-2">
                Join Meat Mechanic
              </h3>
              <p className="text-[#2C7A7B]">
                Get exclusive recipes delivered to your inbox
              </p>
            </div>

            <form id="subscribe-modal-form" data-readdy-form onSubmit={handleSubscribeSubmit} className="space-y-4">
              <div>
                <label htmlFor="modal-name" className="block text-sm text-[#2C7A7B] mb-2">
                  Name
                </label>
                <input
                  type="text"
                  id="modal-name"
                  name="name"
                  required
                  className="w-full border-2 border-gray-200 rounded-lg px-4 py-3 text-[#1A4D4D] focus:outline-none focus:border-[#06B6D4] transition-colors"
                />
              </div>

              <div>
                <label htmlFor="modal-email" className="block text-sm text-[#2C7A7B] mb-2">
                  Email Address
                </label>
                <input
                  type="email"
                  id="modal-email"
                  name="email"
                  required
                  className="w-full border-2 border-gray-200 rounded-lg px-4 py-3 text-[#1A4D4D] focus:outline-none focus:border-[#06B6D4] transition-colors"
                />
              </div>

              <button
                type="submit"
                className="w-full bg-[#06B6D4] hover:bg-[#0891b2] text-white py-4 rounded-lg text-sm uppercase tracking-widest font-medium transition-all duration-300 whitespace-nowrap"
              >
                Subscribe Now
              </button>
            </form>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}